'use client'
import type { ReactNode } from 'react'

import { Icon } from '@repo/ui'
import { Alert } from '@repo/ui/icons'

import { ButtonLink } from '@/components/common/ButtonLink'

interface ErrorPageProps {
  title: string
  description: ReactNode
  buttonLabel: string
  buttonHref: string
}

export default function ErrorPage({ title, description, buttonLabel, buttonHref }: ErrorPageProps) {
  return (
    <div className="gap-lg flex grow flex-col items-center justify-center">
      <div className="gap-sm flex flex-col items-center justify-center">
        <div className="flex items-center gap-[6px]">
          <Icon className="text-foreground size-[28px]" icon={<Alert />} />
          <span className="text-title-xs">{title}</span>
        </div>
        <div className="text-sm">{description}</div>
      </div>
      <ButtonLink
        href={buttonHref}
        mode="internal"
        buttonProps={{ variant: 'secondary', label: buttonLabel }}
      />
    </div>
  )
}
